var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ckx-header',[_vm._v("header")]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.$route.meta.keepAlive)?_c('keep-alive',[_c('router-view',{staticClass:"router"},[_vm._v("路由视图")])],1):_vm._e()],1),_vm._v(" "),_c('ckx-footer',[_vm._v("footer")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a07dc5c8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/index.vue
// module id = null
// module chunks = 